import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    defaultTab: { type: String, default: "0" }
  }

  connect() {
    this.showTab(this.defaultTabValue)
  }

  switch(event) {
    event.preventDefault()
    const tabIndex = event.currentTarget.dataset.tabIndex
    this.showTab(tabIndex)
  }

  showTab(index) {
    // Hide all panels
    this.panelTargets.forEach(panel => {
      panel.classList.add("hidden")
    })

    // Remove active state from all tabs
    this.tabTargets.forEach(tab => {
      tab.classList.remove("bg-white", "text-gray-900", "shadow-sm")
      tab.classList.add("bg-transparent", "text-gray-600", "hover:text-gray-900")
    })

    // Show selected panel
    const selectedPanel = this.panelTargets.find(p => p.dataset.panelIndex === index)
    if (selectedPanel) {
      selectedPanel.classList.remove("hidden")
    }

    // Activate selected tab
    const selectedTab = this.tabTargets.find(t => t.dataset.tabIndex === index)
    if (selectedTab) {
      selectedTab.classList.remove("bg-transparent", "text-gray-600", "hover:text-gray-900")
      selectedTab.classList.add("bg-white", "text-gray-900", "shadow-sm")
    }
  }
}
